import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
    selector: 'app-scatter-four-q-card',
    templateUrl: './scatter-four-q-card.component.html',
    styleUrls: ['./scatter-four-q-card.component.scss'],
    standalone: false
})
export class ScatterFourQCardComponent implements OnInit {
 static key = 100820;

  @Input('item') item:any
  @Input('pageKey') pageKey:any
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>()
  @ViewChild('wordCloud',{static:true}) wordCloud!:ElementRef
  reportType:any;
  
  error_name:any;
  config:any
  data:any
  heading:any
  isDataLoaded=false
  prefrenceConfig:any;
  reqSubcription: Subscription[] = []
  dashboardKey: any;
  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient, 
    private apiService: ApiService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
  ) {
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((query:any)=>{
      this.loadApiData()
    })
    )
    this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
 
      this.dashboardKey = decryptedParams["ds_key"];
    
    });
   }
  ngOnInit(): void {
    const observer = new ResizeObserver((e:any) => {
      this.onSizeChange.emit(e[0].contentRect.height)
    });
    observer.observe(this.wordCloud.nativeElement);
    this.loadlineConfig()
  }

  loadlineConfig(){
    this.heading = this.item.config['report_heading']
    this.config={
    xAxisVar: this.item.config['x_axis']['api_resp_column_nm'],
    yAxisVar: this.item.config['y_axis']['api_resp_column_nm'],
}

    // Restore persisted showBy selection on init (same pattern as icon-chart)
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    const persistedShowBy = this.filterService.getShowBySelection(widgetKey);
    if (persistedShowBy) {
      this.reportType = persistedShowBy;
    }
}
 showByChanges(values:any) {
  this.reportType = values;
  this.loadApiData(values)
 }

  loadApiData(reportType?:string) {
    let api = this.item.config['list_of_api'] || undefined;

    if((this.filterService.isEmptyObject(this.filterService.baseQuery) == false)) {
      // API Payload
      let obj:any = {"api_key" :  "200330"}//api.api_key ||

      // Use persisted showBy from localStorage if reportType not set yet (e.g. on page refresh)
      if (!this.reportType) {
        const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
        this.reportType = this.filterService.getShowBySelection(widgetKey);
      }

      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query["report_typ"] = this.reportType ?? this.filterService.report_type;
      query["module_key"] = this.apiService.getModuleKey();

      let endPoint = this.item.config?.["list_of_api_endpoint"] ? this.item.config?.["list_of_api_endpoint"] : this.apiService.executionUrl;

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint}`, query).subscribe((res:any)=> {
          // API data will be automatically passed to scatter-chart component
          // Expected format: Array of objects with fields like:
          // id, name, territory, total_patients, discontinued_files, discontinuation_rate
          this.isDataLoaded = true;
          this.data = res == null ? [] : res;
          this.error_name = ''
        },(err:any)=>{
          console.log(err)
          this.data = []
          this.isDataLoaded = true;
          this.error_name = friendlyApiErrorMessage(err);
        })
      )
    
    }
}

ngOnDestroy(): void {
  this.reqSubcription.forEach(res=> res.unsubscribe())
}

}
